import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import JudgesUpload from './JudgesUpload';
import OtherUserUpload from './OtherUserUpload';
import ParticipantsUpload from './ParticipantsUpload';
import ModeratorInterpreterUpload from './ModeratorInterpreterUpload';
import SchoolUpload from './SchoolUpload';
import SpecialAwardsUpload from './SpecialAwardsUpload';
import FlexFlowUpload from './FlexFlowUpload';
import { useState } from 'react';
import { useEffect } from 'react';
import { IState, ReduxMap } from '../../redux/redux';

interface IProps extends IState{

}

const Import = (props: IState) => {
  const [callParticipant, setCallParticipant] = useState('');

  useEffect(()=>{
    setCallParticipant(props.Settings?.text.ParticipantLabel ?? 'Participant');
  },[props.Settings]);

  return(
    <div className='bumper-l bumper-out-l'>
      <Tabs>
        <TabList>
          <Tab>{callParticipant}s</Tab>
          <Tab>Schools</Tab>
          <Tab>Judges</Tab>
          <Tab>Other Users</Tab>
          <Tab>Proctors & Interpreters</Tab>
          <Tab>Special Awards</Tab>
          <Tab data-testid="import-tab-flex">Flex Flows</Tab>
        </TabList>
        <TabPanel>
          <div className='bumper-l bumper-out-l'>
            <ParticipantsUpload />
          </div>
        </TabPanel>
        <TabPanel>
          <div className='bumper-l bumper-out-l'>
            <SchoolUpload />
          </div>
        </TabPanel>
        <TabPanel>
          <div className='bumper-l bumper-out-l'>
            <JudgesUpload />
          </div>
        </TabPanel>
        <TabPanel>
          <div className='bumper-l bumper-out-l'>
            <OtherUserUpload />
          </div>
        </TabPanel>
        <TabPanel>
          <div className='bumper-l bumper-out-l'>
            <ModeratorInterpreterUpload/>
          </div>
        </TabPanel>
        <TabPanel>
          <div className='bumper-l bumper-out-l'>
            <SpecialAwardsUpload />
          </div>
        </TabPanel>
        <TabPanel>
          <div className='bumper-l bumper-out-l'>
            <FlexFlowUpload />
          </div>
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default ReduxMap(Import)